import React from 'react';
import {PathUtility} from 'src/shared/constants/PathBuilder';

import type {CourseDefinitionSimpleResponse} from 'src/api/ProactApiClient';
import {CourseDefinitionTable} from 'src/pages/Modules/Training/shared/CourseDefinitionTable/CourseDefinitionTable';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {TrainingDocumentTitle} from '../../../../../../app/training/courseContentValidation';
import {useAppNavigate} from 'src/shared/hooks/useAppNavigate';

const ListCourseDefinitions: React.FC = () => {
  useSetDocumentTitle(TrainingDocumentTitle);
  const navigate = useAppNavigate();

  const handleNavigateTo = (row: CourseDefinitionSimpleResponse) =>
    navigate(PathUtility.TrainingCourseView(String(row.id), 'build'));

  return (
    <CourseDefinitionTable
      identifier="manage-training-table"
      onViewRowClick={handleNavigateTo}
    />
  );
};

export default ListCourseDefinitions;
